import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var venueListRes;
export const venueListTodo = createAsyncThunk('venueList', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/view_venue_list',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "status": data.status,
                "temp": data.temp,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return venueListRes = res.data
    } catch (error) {
        return venueListRes = error.response.data
    }
})


const venueListSlice = createSlice({
    name: 'venueList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(venueListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('venueList', state.data)
            }
        });
        builder.addCase(venueListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default venueListSlice.reducer; 